import styled from 'styled-components';
import { useState, useEffect } from 'react';
// utils
import { getKoreaDate } from 'lib/utils/format/time';
// styles
import { palette } from 'cds/styles';

/**
 * 사이드 클래스 수강연장 / 강의이동
 * @param {object} props
 * @param {boolean} props.openFlag 개강 여부
 * @param {string} props.openDate 개강 날짜
 * @param {import('types/slices/class').Package[]} props.packageList 수강권 종류
 * @param {boolean} props.isMission 미션 존재 여부
 */
const Detail = ({ openFlag, openDate, packageList, isMission }) => {
  const [startDate, setStartDate] = useState('');
  const [packageMessage, setPackageMessage] = useState('');

  useEffect(() => {
    const packList = [];

    packageList.forEach(pack => {
      if (pack.type === 'S') {
        if (~pack.name?.indexOf('1개월')) {
          packList.push('1개월');
        } else if (~pack.name?.indexOf('3개월')) {
          packList.push('3개월');
        } else if (~pack.name?.indexOf('12개월')) {
          packList.push('12개월');
        } else if (~pack.name?.indexOf('무제한')) {
          packList.push('평생');
        } else if (~pack.name?.indexOf('평생')) {
          packList.push('평생');
        }
      }
    });

    if (packList.length > 0) {
      setPackageMessage(`${packList.join(' · ')} 수강권`);
    } else {
      setPackageMessage('1개월 수강권');
    }
  }, [packageList]);

  useEffect(() => {
    if (!openDate) {
      return;
    }

    const date = new Date(openDate);
    if (date < getKoreaDate()) {
      setStartDate('즉시 시작');
    } else {
      const transformedDate = openDate.replace(/-/g, '.');
      setStartDate(transformedDate);
    }
  }, [openFlag, openDate]);

  return (
    <Layout>
      <Item>
        <Title>개강날짜</Title>
        <div>
          <Content>{startDate}</Content>
        </div>
      </Item>
      <Item>
        <Title>수강기간</Title>
        <div>
          <Content>{packageMessage} 중 선택</Content>
        </div>
      </Item>
      <Item>
        <Title>장학혜택</Title>
        <div>
          <Content>활동 우수 장학금 100% 환급</Content>
          {isMission && <Content>미션 수행 장학금 10% 환급</Content>}
        </div>
      </Item>
      <Item>
        <Title>주의사항</Title>
        <div>
          <Content>
            인원 마감 시<br />
            가격이 상승될 수 있습니다.
          </Content>
        </div>
      </Item>
    </Layout>
  );
};

const Layout = styled.div`
  padding: 10px 20px;
  background-color: ${palette.background.bg2};
  border-radius: 4px;
`;

const Item = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 0;

  & ~ & {
    border-top: 1px solid ${palette.border.b1};
  }
`;

const Title = styled.span`
  font-family: 'Roboto';
  margin-right: 20px;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
`;

const Content = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export default Detail;
